import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GroupDirectoryTab = ({ currentUser, navigate }) => {
  const [allGroups, setAllGroups] = useState([]);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');

  const refresh = () => axios.get(`${API}/groups/directory`).then(r => setAllGroups(r.data)).catch(() => {});
  useEffect(() => { refresh(); }, []);

  const filtered = allGroups.filter(g => {
    if (search && !`${g.name} ${g.property_city} ${g.property_state}`.toLowerCase().includes(search.toLowerCase())) return false;
    if (filter === 'open' && g.display_status !== 'Open') return false;
    return true;
  });

  return (
    <div data-testid="group-directory-section">
      <div className="section-header">
        <h2>Group Directory</h2>
        <p>Browse all property groups — join from the property page or swap between groups</p>
      </div>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
        <input type="text" placeholder="Search groups..." value={search} onChange={(e) => setSearch(e.target.value)}
          style={{ flex: 1, minWidth: '200px', padding: '10px 14px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '14px' }}
          data-testid="group-search-input" />
        <select value={filter} onChange={(e) => setFilter(e.target.value)}
          style={{ padding: '10px 14px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '14px' }} data-testid="group-filter-select">
          <option value="all">All Groups</option>
          <option value="open">Open Groups</option>
        </select>
      </div>
      <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '16px' }}>{filtered.length} groups</p>
      {filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>No groups yet. Visit a property page to start one!</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {filtered.map(g => {
            const isMember = g.members?.some(m => m.user_id === currentUser?.user_id);
            return (
              <div key={g.group_id} style={{ background: isMember ? '#f0fdf4' : 'white', border: `1px solid ${isMember ? '#86efac' : '#e5e7eb'}`, borderRadius: '10px', padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }} data-testid={`dir-group-${g.group_id}`}>
                <div style={{ flex: 1, minWidth: '200px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <strong style={{ fontSize: '15px' }}>{g.name}</strong>
                    <span style={{ fontSize: '10px', fontWeight: '700', padding: '2px 8px', borderRadius: '10px', background: g.display_status === 'Open' ? '#d1fae5' : '#fef2f2', color: g.display_status === 'Open' ? '#059669' : '#ef4444' }}>
                      {g.display_status}
                    </span>
                    <span style={{ fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '10px', background: '#dbeafe', color: '#2563eb' }}>
                      {g.property_city}, {g.property_state}
                    </span>
                  </div>
                  <p style={{ fontSize: '13px', color: '#6b7280', margin: '2px 0' }}>
                    {g.group_type} &middot; {g.spots_taken}/{g.max_spots} members
                    {g.spots_available > 0 && <span style={{ color: '#059669', fontWeight: '600' }}> &middot; {g.spots_available} spot{g.spots_available !== 1 ? 's' : ''} open</span>}
                  </p>
                  {g.members?.length > 0 && (
                    <p style={{ fontSize: '12px', color: '#4b5563', margin: '2px 0' }}>
                      Members: {g.members.map(m => m.name).join(', ')}
                    </p>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  {isMember && <span style={{ fontSize: '12px', color: '#059669', fontWeight: '600', padding: '4px 10px', background: '#d1fae5', borderRadius: '6px' }}>Your Group</span>}
                  <button className="btn btn-secondary" style={{ padding: '6px 12px', fontSize: '12px' }} onClick={() => navigate(`/properties/${g.property_id}`)} data-testid={`view-property-${g.group_id}`}>
                    View Property
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default GroupDirectoryTab;
